
import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";


import { Link, useNavigate, useParams } from "react-router-dom";
import { UpdateNewFranchiseeCharges } from "./component";


const UpdateNewCharges = (props) => {
 const { id,cohortId, franchiseeId } = useParams();
  const navigate = useNavigate(); 


 const [loading, setLoading] = useState(false);
const [newCharges, setNewCharges]= useState([])

 const [selectedChargeIds, setSelectedChargeIds] = useState([]);




 useEffect(()=>{
 handleAllGetFranchiseeCharges()
 },[])
 
 
 const handleAllGetFranchiseeCharges = (franchiseeId) => {
   props.getDataFromAPI(
     `/dashboard/api/v2/admin/platform/charge`,
     "GET",
     undefined,
     (response) => {
       setNewCharges(response);
     },
     (err) => {
       console.log("error---", err);
       toastr.error("Failed", "Unable to fetch franchisee charge details");
     }
   );
 };
 const handleCheckboxChange = (chargeId) => {
 
    if (selectedChargeIds.includes(chargeId)) {
      setSelectedChargeIds(selectedChargeIds.filter((id) => id !== chargeId));
    } else {
      setSelectedChargeIds([...selectedChargeIds, chargeId]);
    }
  };
  
 
const handleAddNeweMapCharges = () => {
  
  if (selectedChargeIds.length === 0) {
    toastr.error("Error", "No charges selected");
    return;
  }

  
  const payload = selectedChargeIds;

  props.getDataFromAPI(
    `/dashboard/api/v2/admin/platform/beneficiary/franchisee/${franchiseeId}/charge`,
    "POST",
    payload, 
    (response) => {
      console.log("Update response", response);
      toastr.success("Success", "Charges add successfully");
      navigate(-1); 
    },
    (err) => {
      console.log("Update error", err);
      toastr.error(err.message);
    }
  );
};



  return (
    <UpdateNewFranchiseeCharges
    
      loading={loading}
      handleCheckboxChange={handleCheckboxChange}
      newCharges={newCharges}
      selectedChargeIds={selectedChargeIds}
      handleAddNeweMapCharges={handleAddNeweMapCharges}
    />
  );
};
function mapStateToProps({ props }) {
  return {
    props,
  };
}
export default connect(mapStateToProps, {
  getDataFromAPI,
 
})(UpdateNewCharges);
